import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./preview.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";
import { FaMinus, FaPlus } from "react-icons/fa6";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../CartContext/CartContext";
import { IoMdCart } from "react-icons/io";
import { GrMoney } from "react-icons/gr"

const Preview = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const productId = location.state?.product;
    console.log(productId)
    const isLoggedIn = localStorage.getItem("token");
    const { addToCart } = useCart();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [product, setProduct] = useState(null);
    const [selectedAroma, setSelectedAroma] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const CustomPrevArrow = (props) => {
        const { onClick } = props;
        return (
            <div className="custom-arrow custom-prev" onClick={onClick}>
                <FaChevronLeft size={30} color="white" />
            </div>
        );
    };

    const CustomNextArrow = (props) => {
        const { onClick } = props;
        return (
            <div className="custom-arrow custom-next" onClick={onClick}>
                <FaChevronRight size={30} color="white" />
            </div>
        );
    };
    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await fetch(`/api/preview/products/${productId}`);
                if (!response.ok) {
                    throw new Error('Product not found');
                }
                const data = await response.json();
                setProduct(data);
                setSelectedAroma(data.aromas[0]);
                setSelectedSize(data.aromas[0].sizes[0]);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        if (productId) {
            fetchProduct();
        } else {
            setError("Product ID not provided");
            setLoading(false);
        }
    }, [productId]);

    const handleAromaChange = (aroma) => {
        setSelectedAroma(aroma);
        setSelectedSize(aroma.sizes[0]);
        setQuantity(1);
    };

    const handleSizeChange = (size) => {
        setSelectedSize(size);
        setQuantity(1);
    };

    const handleAddToCart = () => {
        if (!selectedSize) {
            alert("Please select a size");
            return;
        }

        const cartItem = {
            id: product._id.$oid,
            productId: product.productId,
            productName: product.productName,
            aroma: selectedAroma.name,
            size: `${selectedSize.size}${selectedSize.unit}`,
            unit: selectedSize.unit,
            sizeId: selectedSize.sizeId,
            price: selectedSize.sellingPrice,
            quantity,
            image: selectedAroma.images[0],
        };

        addToCart(cartItem);
        alert(`${product.productName} has been added to the cart!`);
        navigate("/cart");
    };

    const handleBuyNow = () => {
        if (!selectedSize) {
            alert("Please select a size");
            return;
        }

        const cartItem = {
            id: product._id.$oid,
            productId: product.productId,
            productName: product.productName,
            aroma: selectedAroma.name,
            size: `${selectedSize.size}${selectedSize.unit}`,
            unit: selectedSize.unit,
            sizeId: selectedSize.sizeId,
            price: selectedSize.sellingPrice,
            quantity,
            image: selectedAroma.images[0],
        };

        addToCart(cartItem);
        if (isLoggedIn) {
            navigate("/checkout");
        } else {
            alert("Please login to proceed with checkout");
            navigate("/login", { state: { from: "/checkout" } });
        }
    };

    const increaseQuantity = () => {
        setQuantity((prev) => (prev < selectedSize.quantity ? prev + 1 : prev));
    };

    const decreaseQuantity = () => {
        setQuantity((prev) => (prev > 1 ? prev - 1 : prev));
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    if (!product) {
        return <div className="error">Product not found</div>;
    }

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
    };

    return (
        <>
            <div className="breadcrumb-wrap bg-f br-2 ">
                <div className="container">
                    <div className="breadcrumb-title" style={{ padding: "0" }}>
                    </div>
                </div>
            </div>
            {/* <div className="preview-container">
            
            <div className="d-flex row previewcontiner">
                <div className="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-1">
                    
                    <div className="imageslider">
                        <Slider {...sliderSettings}>
                            {selectedAroma.images.map((img, index) => (
                                <div key={index}>
                                    <img
                                        src={`${img}`}
                                        alt={`Product ${index + 1}`}
                                        style={{ width: '100%', height: '65vh', objectFit: 'contain' }}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
                    <div >
                    
                        <div className="product-detail">
                            <h1 className="productname">{product.productName}</h1>
                            <div className="productprice">
                                <div className="sellingprice">Rs.{selectedSize.sellingPrice}</div>
                                <div className="originalprice">MRP: Rs.{selectedSize.price}</div>
                            </div><h6 style={{ margin: "2%" }}>(Incl. of all taxes)</h6>
                            <div className="discount">
                                {selectedSize.offer}% OFF
                            </div>

                            <div className="productcap">{product.caption}</div>

                            <div className="aroma">
                                <strong>Fragrances:</strong><br />
                                <div style={{ display: "flex", gap: "10px",flexWrap:"wrap" }}>
                                    {product.aromas.map((aroma) => (
                                        <button
                                            key={aroma}
                                            className="aromaname"
                                            onClick={() => handleAromaChange(aroma)}
                                            style={{
                                                backgroundColor: selectedAroma === aroma ? "#14467b" : "#fff",
                                                color: selectedAroma === aroma ? "#fff" : "#000",
                                            }}
                                        >
                                            {aroma.name}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {selectedSize.quantity < 5 && (
                                <p style={{ marginTop: "10px", color: "red" }}>
                                    <strong>Limited Stock:</strong> {selectedSize.quantity} left
                                </p>
                            )}

                            <div className="ProductSizes">
                                <strong>Size</strong>
                                <div style={{ display: "flex", gap: "10px" }}>
                                    {selectedAroma.sizes.map((size) => (
                                        <button
                                            className="sizelist"
                                            key={size}
                                            onClick={() => handleSizeChange(size)}
                                            style={{
                                                backgroundColor: selectedSize === size ? "#14467b" : "#fff",
                                                color: selectedSize === size ? "#fff" : "#000",
                                            }}
                                        >
                                            {size.size} {size.unit}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="d-flex gap-3 buybuttons">
                                <div className="quantityselector">
                                    <button className="minusbutton" onClick={decreaseQuantity}><FaMinus /></button>
                                    <span className="productquantity">{quantity}</span>
                                    <button className="plusbutton" onClick={increaseQuantity}><FaPlus /></button>
                                </div>
                                <div className="previewaddtocart">
                                    <button className="previewaddtocartbutton" onClick={handleAddToCart}>ADD TO CART</button>
                                </div>
                                <div className="buynow">
                                    <button className="buynowbutton" onClick={handleBuyNow}>BUY NOW</button>
                                </div>
                            </div>
                        </div>
                        <div className="preproductdesc">
                            <div>
                                <h4>Description</h4>
                                <p>{product.description}</p>

                            </div>
                            <div >
                                <h4>Uses</h4>
                                {product.uses && (<p>{product.uses}</p>)}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
<br/>
            <Link to={"/products"} className="backtoproduct" ><FaArrowLeft />Back to list</Link>
        </div> */}

            <div className="preview-container">
                <div className="d-flex row  previewcontiner">
                    <div className="col-xl-1 order-1"></div>
                    <div className="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
                        <div className="imageslider">
                            <div className="discount_price_container">
                                <h6 style={{ color: "white", marginTop: "4px" }} className="new_karthik_heading_here">{selectedSize.offer}% OFF</h6>
                            </div>
                            
                            <Slider {...sliderSettings} >
                                {selectedAroma.images.map((img, index) => (
                                    <div key={index}>
                                        
                                        <img
                                            src={`${img}`}
                                            alt={`Product ${index + 1}`}
                                            style={{
                                                width: "100%",
                                                height: "65vh",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                ))}
                            </Slider>

                        </div>
                    </div>

                    <div className="col-xl-6 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-3">
                        <div>
                            
                            <div className="product_detail_new_karthik">
                                
                                <div className="new_karthik_product_container">
                                    <div>
                                        <p style={{color:"black"}}>{product.caption}</p>
                                        <h4>{product.productName}</h4>
                                    </div>

                                    <div >
                                        
                                        <div className="include_container">
                                            <h4 className="heading_karthik_new_size_sellingprice new_karthik_heading_here">₹{selectedSize.sellingPrice}.00 <span className="include_text">(Incl. of all taxes)</span></h4>
                                        </div>
                                        <h4 className="heading_karthik_new_size new_karthik_heading_here" >MRP ₹{selectedSize.price}.00</h4>
                                    </div>
                                </div>

                                <div className="ProductSizes">
                                    <h6 style={{ textAlign: "start" }}>Fragrances:</h6>

                                    <div
                                        style={{ display: "flex", gap: "10px" }}
                                    >
                                        {product.aromas.map((aroma) => (
                                            <button
                                                key={aroma}
                                                className="sizelist"
                                                onClick={() => handleAromaChange(aroma)}
                                                style={{
                                                    backgroundColor:
                                                        selectedAroma === aroma ? "#483393  " : "#fff",
                                                    color: selectedAroma === aroma ? "#fff" : "#000",
                                                }}
                                            >
                                                {aroma.name}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="ProductSizes">
                                    <h6 style={{ textAlign: "start" }}>Size</h6>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        {selectedAroma.sizes.map((size) => (
                                            <button
                                                className="sizelist new_karthik_heading_here"
                                                key={size}
                                                onClick={() => handleSizeChange(size)}
                                                style={{
                                                    backgroundColor:
                                                        selectedSize === size ? "#483393" : "#fff",
                                                    color: selectedSize === size ? "#fff" : "#000",
                                                }}
                                            >
                                                {size.size} {size.unit}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="karthik_new_purchanse_product">
                                    <div className="quantityselector">
                                        <button className="minusbutton" onClick={decreaseQuantity}>
                                            <FaMinus />
                                        </button>
                                        <span className="productquantity">{quantity}</span>
                                        <button className="plusbutton" onClick={increaseQuantity}>
                                            <FaPlus />
                                        </button>
                                    </div>

                                    <button className="button_redesign" onClick={handleAddToCart}>Add To Cart &nbsp;<IoMdCart /></button>
                                    <button className="button_redesign" onClick={handleBuyNow}>Buy Now &nbsp;<GrMoney /></button>
                                </div>
                                <hr />
                                <div style={{ textAlign: "justify" }}>
                                    <p style={{color:"black"}}>
                                        <span style={{color:"black",fontWeight:700}}>Description: </span>
                                        {product.description}
                                    </p>
                                    <p style={{color:"black"}}>
                                        <span style={{color:"black",fontWeight:700}}>Uses: </span>
                                        {product.uses}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-1 order-4">
                        
                    </div>
                </div>

                <br />
                <Link to={"/products"} className="backtoproduct">
                    <FaArrowLeft /> &nbsp;
                    Back to List
                    
                </Link>
                
            </div>
        </>
    );
};

export default Preview;